var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"navigate-back",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" Go back "),_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
      content: _vm.$t('tooltip.other.back').toString(),
    }),expression:"{\n      content: $t('tooltip.other.back').toString(),\n    }"}],staticClass:"navigate-back__icon",attrs:{"src":require("@/assets/images/common/back.png"),"alt":"Back Icon"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }